// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileMenu_mobile-menu__lMQY- {
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #FFF;
  border-top: 1px solid var(--gray-100);
  height: 66px;
  z-index: 4;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_item__-7s0y {
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  width: 100%;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_item__icon__GxwVh {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  position: relative;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_item__name__rz3aU {
  font-size: 10px;
  text-align: center;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC .MobileMenu_item__name__rz3aU {
  color: var(--accent-color);
  font-weight: 700;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC .MobileMenu_item__icon__GxwVh svg {
  fill: var(--accent-color);
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC .MobileMenu_stroke-icon__dOgwh svg {
  fill: none;
  stroke: var(--accent-color);
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC .MobileMenu_circle-icon__RIfhn svg circle {
  fill: var(--accent-color);
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC::after {
  content: "";
  position: absolute;
  top: 0;
  height: 2px;
  background: var(--accent-color);
  width: calc(100% - 28px);
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC.MobileMenu_is-more__ryJI7 .MobileMenu_item__icon__GxwVh {
  background: var(--accent-color);
  border-radius: 50%;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_is-active__K9RXC.MobileMenu_is-more__ryJI7 .MobileMenu_item__icon__GxwVh svg circle {
  fill: white;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_quantity-indicator__PinMP {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 11px;
  line-height: 11px;
  background: #FF3C3C;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid #FAFAFA;
  color: #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MobileMenu_mobile-menu__lMQY- .MobileMenu_quantity-indicator__PinMP.MobileMenu_quantity-indicator__bigger__RSPQt {
  width: 26px;
  height: 26px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/MobileMenu/MobileMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,YAAA;EACA,UAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACN;AAEI;EACE,eAAA;EACA,kBAAA;AAAN;AAKI;EACE,0BAAA;EACA,gBAAA;AAHN;AAOM;EACE,yBAAA;AALR;AAUM;EACE,UAAA;EACA,2BAAA;AARR;AAcQ;EACE,yBAAA;AAZV;AAiBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,+BAAA;EACA,wBAAA;EACA,8BAAA;EACA,+BAAA;AAfN;AAmBM;EACE,+BAAA;EACA,kBAAA;AAjBR;AAoBU;EACE,WAAA;AAlBZ;AAyBE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAvBN","sourcesContent":[".mobile-menu {\n  position: fixed;\n  display: flex;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: #FFF;\n  border-top: 1px solid var(--gray-100);\n  height: 66px;\n  z-index: 4;\n\n  .item {\n    position: relative;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    cursor: pointer;\n    width: 100%;\n\n    &__icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 24px;\n      height: 24px;\n      position: relative;\n    }\n  \n    &__name {\n      font-size: 10px;\n      text-align: center;\n    }\n  }\n\n  .is-active {\n    .item__name {\n      color: var(--accent-color);\n      font-weight: 700;\n    }\n\n    .item__icon {\n      svg {\n        fill: var(--accent-color);\n      }\n    }\n\n    .stroke-icon {\n      svg {\n        fill: none;\n        stroke: var(--accent-color);\n      }\n    }\n\n    .circle-icon {\n      svg {\n        circle {\n          fill: var(--accent-color);\n        }\n      }\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      height: 2px;\n      background: var(--accent-color);\n      width: calc(100% - 28px);\n      border-bottom-left-radius: 50%;\n      border-bottom-right-radius: 50%;\n    }\n\n    &.is-more {\n      .item__icon {\n        background: var(--accent-color);\n        border-radius: 50%;\n\n        svg {\n          circle {\n            fill: white;\n          }\n        }\n      }\n    }\n  }\n\n  .quantity-indicator {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    font-size: 11px;\n    line-height: 11px;\n    background: #FF3C3C;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #FAFAFA;\n    color: #FAFAFA;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.quantity-indicator__bigger {\n      width: 26px;\n      height: 26px;\n      font-size: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile-menu": `MobileMenu_mobile-menu__lMQY-`,
	"item": `MobileMenu_item__-7s0y`,
	"item__icon": `MobileMenu_item__icon__GxwVh`,
	"item__name": `MobileMenu_item__name__rz3aU`,
	"is-active": `MobileMenu_is-active__K9RXC`,
	"stroke-icon": `MobileMenu_stroke-icon__dOgwh`,
	"circle-icon": `MobileMenu_circle-icon__RIfhn`,
	"is-more": `MobileMenu_is-more__ryJI7`,
	"quantity-indicator": `MobileMenu_quantity-indicator__PinMP`,
	"quantity-indicator__bigger": `MobileMenu_quantity-indicator__bigger__RSPQt`
};
export default ___CSS_LOADER_EXPORT___;
